
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import ar from "./locales/ar.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
    },
    lng: "ar", // تعيين اللغة العربية كلغة افتراضية
    fallbackLng: "ar", // استخدام العربية كلغة احتياطية
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
